import { render } from "./AddManufacturer.vue?vue&type=template&id=aabc4e6c&ts=true"
import script from "./AddManufacturer.vue?vue&type=script&lang=ts"
export * from "./AddManufacturer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__